// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"187":"b9e6dde7be27d2cb","735":"7325ee05f63dd7ba"}[chunkId] + ".js";
};